export default {
    intro: `ดูหัวข้อการเขียน แล้วลองเขียนข้อความของตัวเองดูสิ<br />
            ลองอ่านข้อความของเพื่อนๆ แล้วโหวตให้ข้อความที่ชอบด้วยนะ`,
    buttons: {
        cancel: 'ยกเลิก',
        submit: 'ส่ง',
    },
    options: {
        timer: {
            title: 'ตั้งค่าตัวจับเวลา',
            inputTime: 'เวลาเขียน',
            voteTime: 'เวลาโหวต',
        },
        example: {
            title: 'แสดงคำตอบตัวอย่าง',
            description: 'คำตอบตัวอย่างจะแสดงบนหน้าจอนักเรียน',
        },
        votesPerStudent: {
            title: 'ตั้งค่าจำนวนโหวตต่อนักเรียน',
        },
    },
    noTitleCard: 'เป็นการ์ดที่ไม่มีชื่อ',
    noContentCard: 'เป็นการ์ดที่ไม่มีเนื้อหา',
    exampleAnswer: 'คำตอบตัวอย่าง',
    tabs: {
        check: '1.ดูหัวข้อการเขียน',
        write: '2.เขียนการ์ด',
        vote: '3.ดำเนินการโหวต',
        result: '4.ผลการโหวต',
    },
    tabStudent: {
        write: 'ดูหัวข้อการเขียน แล้วลองเขียนความคิดของตัวเองออกมาสิ',
        previousVote: 'ก่อนโหวต ลองอ่านข้อความของเพื่อนๆ กันนะ',
        vote: 'โหวตให้ข้อความที่ชอบกันเลย',
        result: 'มาดูข้อความที่เพื่อนๆ ชอบมากที่สุดกัน!',
    },
    card: {
        title: 'ยังไม่ได้เขียนชื่อเลย 😶',
        content: 'ยังไม่ได้เขียนเนื้อหาอะไรเลย 😵',
    },
    cardWritingArea: {
        titlePlaceholder: 'กรอกชื่อ (ประมาณ 30 ตัวอักษร)',
        contentPlaceholder: 'กรอกเนื้อหา ',
        unsubmittedStudents: 'ยังไม่ส่ง {count} คน',
    },
    loading: {
        voteStart: 'เริ่มโหวต',
        voteSubmit: 'กำลังส่งคำตอบของนักเรียนที่ยังเขียนอยู่โดยอัตโนมัติ...',
        voteCollect: 'กำลังรวบรวมข้อความของนักเรียนคนอื่น...',
        voteResult: 'กำลังนับคะแนนโหวต',
        readNext: 'กำลังเตรียมหัวข้อการเขียนถัดไป',
    },
    vote: {
        selfVote: 'ไม่สามารถโหวตให้ตัวเองได้',
        voteLimit: 'ใช้สิทธิ์โหวตครบหมดแล้ว',
    },
    student: {
        inPlay: {
            readyText: `ดูหัวข้อการเขียนไป<br />แล้วคิดว่าจะเขียนอะไรดี`,
            topic: 'หัวข้อการเขียน',
            foldTopic: 'พับหัวข้อการเขียน',
            imageAlt: 'สื่อรูปภาพ',
            voteRemaining: 'เหลือโหวตอีก {count} ครั้ง',
            waiting: 'กำลังรอ',
        },
        toast: {
            contentLengthWarning: 'กรอกเนื้อหาได้ไม่เกิน 2,000 ตัวอักษร',
            titleLengthWarning: 'เขียนชื่อได้ไม่เกิน 30 ตัวอักษร',
            inputEndWarning: 'เหลืออีก 15 วินาที เวลาเขียนจะสิ้นสุดในไม่ช้า',
            voteEndWarning: 'เหลืออีก 15 วินาที การโหวตจะสิ้นสุดในไม่ช้า',
        },
    },
    teacher: {
        setting: {
            titlePlaceholder: 'กรอกชื่อหัวข้อการเขียน (สูงสุด 200 ตัวอักษร)',
            textPlaceholder: 'กรอกคำอธิบายหัวข้อการเขียน (สูงสุด 1,000 ตัวอักษร)',
            inputErrorMessage: 'กรุณากรอก',
            delete: 'ลบ',
            register: 'ลงทะเบียน',
            cancel: 'ยกเลิก',
            addQuestion: 'เพิ่มหัวข้อการเขียน',
        },
        inPlay: {
            readyTextInput: `หลังจากอธิบายหัวข้อการเขียนแล้ว <br />
                                    กด 'เริ่มเขียน' ได้เลย`,
            readyTextSubmit: `เมื่อนักเรียนส่งคำตอบ <br />
                                    จะแสดงที่นี่`,
        },
        modal: {
            title: 'การเขียนการ์ด 💬',
            startConfirm: {
                message: 'มีเนื้อหาที่กำลังเขียนอยู่เพื่อเพิ่มหัวข้อการเขียน',
                subMessage: 'หากเริ่มกิจกรรมตอนนี้ เนื้อหาที่เขียนไว้จะถูกลบทั้งหมดและจะไม่ถูกเพิ่มเป็นโจทย์',
                optionalMessage: 'จะเริ่มกิจกรรมเลยไหม?',
                confirmText: 'เริ่มกิจกรรม',
                cancelText: 'เขียนต่อ',
            },
            voteStart: {
                message: 'ยังมีนักเรียนที่กำลังเขียนอยู่',
                subMessage: 'จะส่งการ์ดแบบนี้แล้วเริ่มโหวตเลยไหม?',
                confirmText: 'เริ่มโหวต',
            },
            voteEnd: {
                message: 'เวลาโหวตสิ้นสุดแล้ว',
                subMessage: 'จะดูผลลัพธ์ไหม?',
                confirmText: 'ดูผลลัพธ์',
            },
            questionDelete: {
                message: 'จะลบหัวข้อการเขียนไหม?',
                subMessage: 'หัวข้อการเขียนที่ลบแล้วไม่สามารถกู้คืนได้',
                confirmText: 'ลบ',
            },
        },
        button: {
            step: {
                beforeStart: 'เริ่มเขียน',
                writingEnd: 'สิ้นสุดการเขียน',
                voteEnd: 'สิ้นสุดการโหวต',
                nextTopic: 'หัวข้อการเขียนถัดไป',
                activityStart: 'เริ่มกิจกรรม',
            },
        },
        result: {
            topic: 'หัวข้อการเขียน',
        },
    },
};
